
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.028 4.542A6.758 6.758 0 017.276.375a6.75 6.75 0 016.75 6.758A6.758 6.758 0 111.029 4.542zm11.547 4.645a5.737 5.737 0 00.368-2.054A5.667 5.667 0 0011.74 3.57c-.319.53-.92 1.324-1.665 1.324a2.387 2.387 0 00-.85.085v.078c0 .128.348.475.532.659.458.342.764.85.85 1.417 0 1.133.113 1.48.212 1.565a4.59 4.59 0 011.757.489zM1.61 7.133a5.667 5.667 0 011.176-3.486c.2.367.588.59 1.006.581.573.29 1.08.695 1.487 1.19-.3.185-.572.411-.808.673l-.07.069c-.196.19-.476.463-.595.47A1.19 1.19 0 002.58 7.855c.001.081.02.161.057.234l.637 1.275a7.41 7.41 0 00.348 2.16A5.667 5.667 0 011.61 7.133zm3.733 5.326c.62.225 1.274.34 1.934.34v.021a5.667 5.667 0 004.816-2.62 4.696 4.696 0 00-1.353-.418c-1.225 0-1.225-1.757-1.225-2.607 0-.128-.316-.444-.511-.638l-.027-.028a2.182 2.182 0 01-.843-1.417c0-1.225 1.246-1.225 1.912-1.225.184-.007.623-.531.893-1.055a5.667 5.667 0 00-7.29-.029c.012.061.012.124 0 .184.008.17.086.17.164.17.85 0 2.755 1.729 2.783 2.536a.638.638 0 01-.708.638c-.127.007-.474.354-.659.538a2.21 2.21 0 01-1.416.85c-.057 0-.142 0-.142.071l.616 1.183a.538.538 0 01.057.234c0 .772.17 2.026.538 2.4.257.224.422.534.46.872z","fill":"#585858"}})])
          )
        }
      }
    